import React from 'react'
import { CostItem } from '../CostItem'
import * as S from './styled'

export type Props = {
  value: number | string
  withSeparator?: boolean
}

export const EstimatedProfit = ({ value, withSeparator = true }: Props) => {
  return (
    <S.Container $withSeparator={withSeparator}>
      <CostItem name="Estimated profit per unit sold" value={value} bold />
    </S.Container>
  )
}
